/* ReliableGoods — CRO product landing page behaviour.
   Self-contained; boots on any page containing [data-cro="landing"]. */
(function () {
  function init(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var sel = root.querySelector('[data-cro-variant]');
    var priceEls = [].slice.call(root.querySelectorAll('[data-cro-price]'));
    var totalEls = [].slice.call(root.querySelectorAll('[data-cro-total]'));
    var wasEl = root.querySelector('.cro-lp__was');
    var priceRow = root.querySelector('.cro-lp__pricerow');
    function toNum(s) { return parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0; }
    function setAll(list, v) { list.forEach(function (el) { el.textContent = v; }); }
    var fromLbl = null;
    /* Lead with the cheapest price: show "From $<min>" until the shopper picks a size. */
    function addFrom(minStr) {
      setAll(priceEls, minStr);
      if (wasEl) { wasEl.style.display = 'none'; }
      if (priceRow && !fromLbl) {
        fromLbl = document.createElement('span');
        fromLbl.className = 'cro-lp__fromlbl';
        fromLbl.textContent = 'From';
        fromLbl.style.cssText = 'font:600 14px/1 var(--cro-sans,ui-sans-serif,system-ui,sans-serif);color:var(--cro-muted,#8a8575);margin-right:8px;align-self:center';
        priceRow.insertBefore(fromLbl, priceRow.firstChild);
      }
    }
    function clearFrom() { if (fromLbl && fromLbl.parentNode) { fromLbl.parentNode.removeChild(fromLbl); fromLbl = null; } }
    function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }
    /* Recompute every bundle tier from the given variant price so tile prices,
       strikethroughs, "Save" amounts and data-price always equal what /cart will
       charge. Shopify floors percentage discounts on the line total in cents —
       mirror that exactly or the button promises a total the cart won't honor. */
    function updateTiers(baseCents) {
      if (!baseCents) return;
      root.querySelectorAll('[data-cro-tier]').forEach(function (b) {
        var qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var disc = parseFloat(b.getAttribute('data-disc')) || 0;
        var reg = baseCents * qty;
        var cut = Math.floor(reg * disc / 100);
        var tot = reg - cut;
        b.setAttribute('data-price', fmtMoney(tot));
        var priceEl = b.querySelector('.cro-lp__bprice');
        if (priceEl) {
          if (disc > 0) {
            var s = document.createElement('s');
            s.className = 'cro-lp__breg';
            s.textContent = fmtMoney(reg);
            priceEl.textContent = ' ' + fmtMoney(tot);
            priceEl.insertBefore(s, priceEl.firstChild);
          } else {
            priceEl.textContent = fmtMoney(tot);
          }
        }
        var saveEl = b.querySelector('.cro-lp__bsave');
        if (saveEl && disc > 0) { saveEl.textContent = 'Save ' + fmtMoney(cut); }
        if (b.classList.contains('is-selected')) { setAll(totalEls, fmtMoney(tot)); }
      });
    }
    /* When a size is chosen, sync the headline price AND the Add-to-Cart button to
       that exact variant, recompute the tier tiles from it, and reset the selection
       back to Buy 1 so the shopper re-confirms quantity at the new price. */
    function pickOption(o) {
      if (!o) return;
      var p = o.getAttribute('data-price');
      if (!p) return;
      clearFrom();
      setAll(priceEls, p);
      setAll(totalEls, p);
      var tiers = root.querySelectorAll('[data-cro-tier]');
      if (tiers.length) {
        tiers.forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        tiers[0].classList.add('is-selected');
        tiers[0].setAttribute('aria-checked', 'true');
        var qi = root.querySelector('[data-cro-qty]');
        if (qi) qi.value = tiers[0].getAttribute('data-qty') || 1;
        updateTiers(Math.round(toNum(p) * 100));
      }
    }
    if (sel) {
      var minStr = null, minNum = Infinity, firstNum = null, varies = false;
      [].forEach.call(sel.options, function (o) {
        var n = toNum(o.getAttribute('data-price'));
        if (firstNum === null) { firstNum = n; } else if (n !== firstNum) { varies = true; }
        if (!o.disabled && n > 0 && n < minNum) { minNum = n; minStr = o.getAttribute('data-price'); }
      });
      if (varies && minStr) { addFrom(minStr); }
      sel.addEventListener('change', function () { pickOption(sel.options[sel.selectedIndex]); });
      /* Server-rendered tier prices are computed from the product's base price; if the
         page loads with a different variant preselected (?variant= URLs), realign. */
      var cur = sel.options[sel.selectedIndex];
      if (cur) { updateTiers(Math.round(toNum(cur.getAttribute('data-price')) * 100)); }
    }
    /* Gallery tap/swipe behaviour is owned exclusively by the cro-gallery-swipe section
       (CSS scroll-snap track). It used to be duplicated here too, which raced with that
       section's clone-and-replace listener setup on slow mobile loads — a likely cause of
       the "dead click" pattern seen in Clarity. Removed rather than relocated so there is
       only ever one system binding to the gallery thumbnails. */
    /* Tapping the star rating jumps to the reviews section (expected behaviour). */
    var ratingEl = root.querySelector('.cro-lp__rating');
    var reviews = document.getElementById('cro-lp-reviews');
    if (ratingEl && reviews) {
      ratingEl.style.cursor = 'pointer';
      ratingEl.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('a')) { return; }
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    /* "Receive it by <date>" line: computed client-side from today so it's always accurate,
       never a stale server-rendered date served from cache. */
    var deliveryEl = root.querySelector('[data-cro-delivery]');
    if (deliveryEl) {
      var dateSpan = deliveryEl.querySelector('[data-cro-delivery-date]');
      var days = parseInt(deliveryEl.getAttribute('data-days'), 10) || 7;
      if (dateSpan) {
        var d = new Date();
        d.setDate(d.getDate() + days);
        dateSpan.textContent = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }
    }
    root.querySelectorAll('[data-cro-tier]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-cro-tier]').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true');
        var qi = root.querySelector('[data-cro-qty]'); if (qi) qi.value = b.getAttribute('data-qty');
        var tot = b.getAttribute('data-price');
        clearFrom();
        root.querySelectorAll('[data-cro-total]').forEach(function (el) { el.textContent = tot; });
      });
    });
    function add() {
      if (!form) return;
      var btn = form.querySelector('[data-cro-add]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (res.ok) { window.location.href = '/cart'; }
          else { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } alert((res.d && res.d.description) || 'Could not add to cart.'); }
        })
        .catch(function () { form.submit(); });
    }
    if (form) { form.addEventListener('submit', function (e) { if (e.submitter && !e.submitter.hasAttribute('data-cro-add')) { return; } e.preventDefault(); add(); }); }
    root.querySelectorAll('[data-cro-stickyadd]').forEach(function (b) { b.addEventListener('click', add); });
    var sticky = root.querySelector('[data-cro-sticky]');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(form);
    }
  }
  function boot() { document.querySelectorAll('[data-cro="landing"]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

/* ReliableGoods — the WELCOME20 exit-intent/timed popup that used to live here has been
   removed. It ran globally (including on the comb PDP) at the same time as the Ecomsend
   app's own discount popup, with no coordination between the two — two independent
   systems both listening for the same page-level triggers. Ecomsend is the actively
   managed email-capture system going forward; keeping only one avoids the duplication. */

/* ReliableGoods — quick-add on collection cards. Delegated; only [data-cro-qa-form]. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-cro-qa-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) { throw 0; } return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } form.submit(); });
  });
})();
